export default "__VITE_PUBLIC_ASSET__19f39dcd__"